





























































































































































import {Component, Vue, Prop} from 'vue-property-decorator';
import { setNameLang, makeToast } from '@/modules/budget-request/components/js/some-functions';
import { IBatchUpParams, startBatchUpload, isFileDownloading, startFileDownload, finishFileDownload, checkArchive, triggerBrowserDownload, formatSize, FAT32_LIMIT_BYTES } from '@/modules/budget-request/components/js/budget-upload';
import store from '@/services/store';
import { Ax } from '@/utils';
import { getBudgetText }  from '@/modules/budget-request/components/budget-sum-calc/js/budget-translation';

@Component({
    components: {
    },
    name: 'c-budg-upload'
})
export default class CBubgUpload extends Vue {
    @Prop({
        required: true,
        default: 1
    })
    private status!: number;

    private progress = 0;
    private dictStatusMap: Map<number, any> = new Map();

    private dataLst: any[] = [];

    // компонент уничтожается при переходе на другую вкладку (<b-tabs lazy>),
    // а колбэки начатого скачивания продолжают срабатывать
    private isAlive = true;


    private get usrId(): string | null {
        if (!store.state.user.sub) { return null; }
        return store.state.user.sub;
    }


    private mounted() {
        this.loadAll();
        this.$watch('usrId', () => {
            if (!this.usrId) { return; }
            this.getDataLst();
        });
        this.$watch('status', () => { this.getDataLst(); });
//         alert(`Құрметті пайдаланушылар!
//
// Қазіргі уақытта пакеттік жүктелеуде жиынтық түрде тек "Штат кестесі" нысандары бар екеніне назар аударамыз.
// Қалған есеп айырысу нысандар әзірге тек ММ қимасында жүктеледі.
//
// Функционалдылықты кеңейту бойынша жұмыстар жүргізілуде.
// Түсінгеніңіз үшін рақмет!
//
//
//
// Уважаемые пользователи!
//
// Обращаем ваше внимание, что на текущий момент в пакетной выгрузке в агрегированном виде доступны только формы "Штатного расписания".
// Остальные формы расчетов пока выгружаются только в разрезе ГУ.
//
// Ведутся работы по расширению функциональности.
// Благодарим за понимание!`);
    }

    private beforeDestroy() {
        this.isAlive = false;
    }

    private async getDataLst() {
        const dataLst = await this.loadData();
        this.setStatusName(dataLst);
    }

    private async loadAll() {
        const result = await Promise.all([
            this.loadData(),
            this.loadDictStatus()
        ]);
        this.setStatusName(result[0]);
    }

    private dataUnionStatus(el: any) {
        const obj = this.dictStatusMap.get(el.status);
        el.status = { code: el.status, name_ru: '', name_kk: '', name: '', progress: el.percent };
        if (obj) {
            el.status.name_ru = obj.name_ru;
            el.status.name_kk = obj.name_kk;
            el.status = setNameLang(this.$i18n.locale, el.status);
        }
    }

    private setStatusName(dataLst: any[]) {
        for (const el of dataLst) {
            this.dataUnionStatus(el);
            this.setParamsName(el);
        }
        this.dataLst = dataLst;
    }

    private setParamsName(el: any) {
        if (el.isGkkpCreate !== null) {
            if (el.isGkkpCreate) {
                el.isGkkpText = 'ГККП';
            } else {
                el.isGkkpText = 'АБП/ГУ';
            }
        }
        if (el.isAgregateCreate !== null) {
            if (el.isAgregateCreate) {
                el.isAgregateText = 'Агрег. данные';
            } else {
                el.isAgregateText = 'В разрезе ГУ';
            }
        }
    }

    private async loadDictStatus() {
        let result: any[] = [];
        try {
            const response: any = await fetch('/api-py/get-budget-dict-upload-status-all');
            if (response.status === 200) {
                result = await response.json();
                for (const el of result) {
                    this.dictStatusMap.set(el.code, el);
                }
            } else {
                makeToast(this, 'danger', 'Ошибка загрузки справочника статусов', `${response.status} ${response.statusText}`);
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки справочника статусов', (error as Error).toString());
            result = [];
        }
    }

    private async loadData() {
        this.dataLst = [];
        let result: any[] = [];
        if (!this.usrId) { return []; }
        this.progress = 45;
        try {
            // const response: any = await fetch(`/api/summary/report/list?uid=${this.usrId}&status=${this.status}`);
            const response: any = await fetch(`/api/summary/report/list?uid=${this.usrId}`);
            if (response.status === 200) {
                result = await response.json();
                for (const el of result) {
                    if (el.dtCreate) { el.dtCreate = new Date(el.dtCreate); }
                    if (el.dtFinish) { el.dtFinish = new Date(el.dtFinish); }
                }
            } else {
                makeToast(this, 'danger', 'Ошибка /api/summary/report/', `${response.status} ${response.statusText}`);
                this.progress = 0;
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка /api/summary/report/', (error as Error).toString());
            this.progress = 0;
            result = [];
        } finally {
            this.progress = 100;
        }
        return result;
    }

    private async loadClk(params: any) {
        if (!params.curVariant || !params.curAbp || !params.regionProp) {
            makeToast(this, 'danger', 'Загрузка', 'Выбраны не все параметры!');
            return;
        }
        const p: IBatchUpParams = { cur_year: params.curYear, region: params.regionProp.code, variant: params.curVariant.variant_uuid, abp: params.curAbp.abp, lang: this.$i18n.locale, gu: (params.curGu && params.curGu.code) ? params.curGu.code: null, prg: params.prg, isGkkpCreate: params.isGkkp, guParent: params.guParent };
        if (params.gkkp !== undefined) { p.gkkp = params.gkkp;}
        if (params.isAgregate !== undefined) { p.isAgregateCreate = params.isAgregate; }
        if (params.isConfirm !== undefined) { p.isConfirmDoc = params.isConfirm; }
        if (params.isAddNeed !== undefined) { p.isAdditionalNeed = params.isAddNeed; }
        await startBatchUpload(p, this);
        this.getDataLst();
    }

    private async updateStatus(indx: number) {
        const id = this.dataLst[indx].id;
        let result = null;
        try {
            const response: any = await fetch(`/api/summary/report/status/${id}`);
            if (response.status === 200) {
                result = await response.json();
                this.dataLst[indx].uploadName = result.uploadName;
                if (result.signFileParamsId) {
                    this.$set(this.dataLst[indx], 'signFileParamsId', result.signFileParamsId);
                }
                this.$set(this.dataLst[indx], 'archiveAvailable', !!result.archiveAvailable);
                const tmp = Object.assign({}, this.dataLst[indx]);

                tmp.status = result.status;
                tmp.percent = result.percent;

                this.dataUnionStatus(tmp);
                this.$set(this.dataLst[indx], 'status', tmp.status);
                makeToast(this, 'success', 'Запись обновлена', `id: ${id}`);
            } else {
                makeToast(this, 'danger', 'Ошибка обновления', `${response.status} ${response.statusText}`);
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка обновления', (error as Error).toString());
            result = [];
        }
    }

    // идёт ли уже скачивание файла по данному отчёту
    private isDownloading(id: number, pdf = false): boolean {
        return isFileDownloading(id, pdf);
    }

    // PDF — без изменений: синхронная выгрузка через Ax и blob
    private downloadPdf(indx: number) {
        const pdf = true;
        const id = this.dataLst[indx].id;
        // повторный клик по неактивной иконке — только уведомление, запрос не дублируем
        if (!startFileDownload(id, pdf)) {
            makeToast(this, 'warning', this.tblTitle.attention, this.tblTitle.downloadInProgress);
            return;
        }
        let uplaodName = this.tblTitle.defaultUploadName;
        if (this.dataLst[indx].uploadName) { uplaodName = this.dataLst[indx].uploadName; }
        const urls = `/api/summary/report/getpdffile?id=${id}`;
        Ax<Blob>(
            {
                url: urls,
                method: 'GET',
                responseType: 'blob'
            },
            (data) => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${uplaodName}.zip`);
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(url);
            },
            (error) => {
                // скачивание могло упасть уже после уничтожения компонента (уход на другую вкладку):
                // у мёртвого экземпляра тост не отрисуется, поэтому показываем его от корня
                makeToast(this.isAlive ? this : this.$root, 'danger', 'Ошибка Загрузки', error.toString());
            },
            () => {
                finishFileDownload(id, pdf);
            }
        );
    }

    // XLSX-архив: проверяем доступность и отдаём скачивание менеджеру загрузок браузера
    private async downloadXlsxArchive(indx: number) {
        const row = this.dataLst[indx];
        const id = row.id;
        // кнопка блокируется только на время проверки
        if (!startFileDownload(id)) {
            makeToast(this, 'warning', this.tblTitle.attention, this.tblTitle.downloadInProgress);
            return;
        }
        // после await компонент мог быть уничтожен (уход на другую вкладку)
        const toastTarget = () => (this.isAlive ? this : this.$root);
        try {
            const res = await checkArchive(id);
            if (!res.ok) {
                // причина: суффикс ключа бэка (…archive.generating|failed|expired|forbidden|notFound),
                // без ключа — по HTTP-коду; тексты берём свои, фронт не зависит от dict_translate
                const reason = res.key ? res.key.substring(res.key.lastIndexOf('.') + 1) : ({ 403: 'forbidden', 404: 'notFound', 409: 'generating', 410: 'expired' } as any)[res.status];
                const texts: any = {
                    generating: this.tblTitle.archiveBuilding,
                    failed: this.tblTitle.archiveFailed,
                    expired: this.tblTitle.archiveExpired,
                    forbidden: this.tblTitle.archiveNoAccess,
                    notFound: this.tblTitle.archiveNotFound
                };
                if (reason && texts[reason]) {
                    const variant = (reason === 'forbidden' || reason === 'failed') ? 'danger' : 'warning';
                    makeToast(toastTarget(), variant, this.tblTitle.attention, texts[reason]);
                    // строка могла устареть (архив истёк, сборка завершилась ошибкой и т. п.)
                    if (reason !== 'forbidden') { this.refreshRowIfAlive(id); }
                } else {
                    makeToast(toastTarget(), 'danger', this.tblTitle.archiveCheckError, res.message || `${res.status}`);
                }
                return;
            }
            const info = res.info;
            if (!info || !info.available) {
                makeToast(toastTarget(), 'warning', this.tblTitle.attention, this.tblTitle.archiveExpired);
                this.refreshRowIfAlive(id);
                return;
            }
            let uploadName = this.tblTitle.defaultUploadName;
            if (row.uploadName) { uploadName = row.uploadName; }
            triggerBrowserDownload(`/api/summary/report/archive/${id}/download`, `${uploadName}.zip`);
            const size = info.sizeBytes ? formatSize(info.sizeBytes, this.$i18n.locale) : '';
            let message = getBudgetText('sum_calc_upload.archiveDownloadStarted', [size]);
            if (info.sizeBytes && info.sizeBytes > FAT32_LIMIT_BYTES) {
                message += `. ${this.tblTitle.archiveLargeHint}`;
            }
            makeToast(toastTarget(), 'info', this.tblTitle.attention, message);
        } catch (error) {
            makeToast(toastTarget(), 'danger', this.tblTitle.archiveCheckError, (error as Error).toString());
        } finally {
            finishFileDownload(id);
        }
    }

    // обновляет строку отчёта по id (индекс мог измениться за время запроса)
    private refreshRowIfAlive(id: number) {
        if (!this.isAlive) { return; }
        const indx = this.dataLst.findIndex((el) => el.id === id);
        if (indx >= 0) { this.updateStatus(indx); }
    }

    private dateTimeFormat () {
      return new Intl.DateTimeFormat('ru', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric'
      })
    }

    // ---- переводы
    private getBudgetText(link: string) {  return getBudgetText(link); }

    private get tblTitle() {
        const obj = {
            type: this.getBudgetText('sum_calc_upload.type'), // Тип
            curYear: this.getBudgetText('filter.curYear'), // Плановый период
            variant: this.getBudgetText('filter.variant'), // Версия бюджета
            variantUpload: this.getBudgetText('sum_calc_upload.variantUpload'), // Версия пакетной выгрузки
            abp: this.getBudgetText('sum_calc_upload.abp'), // АБП
            subord: this.getBudgetText('filter.subord'), // Подведомственные
            gu: this.getBudgetText('sum_calc_gu.gu'), // ГУ
            gkkp: this.getBudgetText('filter.uploadType.val1'), // ГККП
            bp: this.getBudgetText('sum_calc_upload.bp'), // БП
            dateTimeCreate: this.getBudgetText('sum_calc_upload.dateTimeCreate'), // Дата и время создания
            dateTimeUpload: this.getBudgetText('sum_calc_upload.dateTimeUpload'), // Дата и время выгрузки
            user: this.getBudgetText('sum_calc_upload.user'), // Пользователь
            uploadStatus: this.getBudgetText('sum_calc_upload.uploadStatus'), // Статус загрузки
            download: this.getBudgetText('button.download'), // Скачать
            refresh: this.getBudgetText('sum_calc_upload.refresh'), // Обновить
            attention: this.getBudgetText('sum_calc_upload.attention'), // Внимание!
            downloadInProgress: this.getBudgetText('sum_calc_upload.downloadInProgress'), // Выгрузка уже началась, пожалуйста ожидайте
            archiveExpired: this.getBudgetText('sum_calc_upload.archiveExpired'), // Срок хранения архива истёк
            archiveNoAccess: this.getBudgetText('sum_calc_upload.archiveNoAccess'), // Нет доступа к архиву
            archiveCheckError: this.getBudgetText('sum_calc_upload.archiveCheckError'), // Не удалось проверить архив
            archiveBuilding: this.getBudgetText('sum_calc_upload.archiveBuilding'), // Архив формируется
            archiveFailed: this.getBudgetText('sum_calc_upload.archiveFailed'), // Ошибка формирования архива
            archiveNotFound: this.getBudgetText('sum_calc_upload.archiveNotFound'), // Выгрузка не найдена
            archiveLargeHint: this.getBudgetText('sum_calc_upload.archiveLargeHint'), // Файл больше 4 ГБ
            defaultUploadName: this.getBudgetText('sum_calc_upload.defaultUploadName'), // Пакетная выгрузка
        }
        return obj;
    }
}
